import React,{ Component } from 'react';
import { connect } from 'react-redux';
import Actions from '../../../Actions';
import Confirm from '../Layout/Confirm';
import { sanitizeData } from '../../../Utilities/Common';

class LocationRow extends Component{

    render(){
        let { token, location: { id, name, sub_locations = [] }, showSubLocations, edit, deleteLocation } = sanitizeData(this.props);
        const count = sub_locations.length;
        return (
            <tr key={id+330}>
                <td><span style={{cursor: "pointer"}} onClick={() => edit(id)} className="btn-link">{name}</span></td><td><span onClick={() => showSubLocations(id)} style={{cursor:"pointer"}} className="btn-link">{count}</span></td><td><Confirm confirm={() => deleteLocation(token,id)} /></td>
            </tr>
        );
    }
}

const mapStateToProps = (state) => ({
    token: state.auth.token,
});
export default connect(mapStateToProps,Actions.locations)(LocationRow);


// WEBPACK FOOTER //
// ./src/Components/App/Locations/LocationRow.js